import { render, staticRenderFns } from "./download.vue?vue&type=template&id=c3544c5c&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"
import style0 from "./download.vue?vue&type=style&index=0&id=c3544c5c&prod&scoped=true&lang=css"
import style1 from "./download.vue?vue&type=style&index=1&id=c3544c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3544c5c",
  null
  
)

export default component.exports